import React, { useCallback, useContext } from 'react'
import { PageContext } from '../../../../contexts/page-context'
import { InstallType } from '../../../../lib/hooks/install-eligibility'
import { MobileOsType } from '../../../../lib/services/facade'
import { navHelper } from '../../../../lib/services/navigation'
import { gnarSpec } from '../../../../lib/tracking/gnar'
import { trackKeyboardInstall } from '../../../../lib/tracking/google-tag-manager/events'
import { waitGnar } from '../../../../lib/utils/promise'
import { ButtonCtaProps } from '../../../ui-lib/button'
import { CtaTrackingProps } from '../types'
import { AppStoreButton } from './app-store-button'

export interface KeyboardInstallButtonCtaProps extends Omit<ButtonCtaProps, 'onClick' | 'text'>, CtaTrackingProps {}

export interface KeyboardInstallButtonBaseProps extends KeyboardInstallButtonCtaProps {
  onClick?: () => void
  installUrl: string
  buttonImg: string
  install: InstallType
}

export const KeyboardInstallButtonBase: React.FC<KeyboardInstallButtonBaseProps> = (props) => {
  const { pageId, slug } = useContext(PageContext)
  const { onClick, install, installUrl, placement, placementInternalName, ...restProps } = props

  const onClickHandler = useCallback(async () => {
    onClick?.()
    await waitGnar(gnarSpec.installKeyboardButtonClick(pageId, slug, placement, placementInternalName))
    trackKeyboardInstall(install === InstallType.Android ? MobileOsType.Android : MobileOsType.iOS, placement)
    navHelper.navigateUrl(installUrl, {
      // TODO: Set up contexts to determine Placement correctly
      campaign: `${pageId}PagePrimaryButton`,
    })
  }, [onClick, pageId, slug, placement, placementInternalName, install, installUrl])

  return <AppStoreButton {...restProps} buttonImg={props.buttonImg} onClick={onClickHandler} />
}
